"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Project = _interopRequireDefault(require("@rsuite/icon-font/lib/file/Project"));

// Generated by script, don't edit it please.
var Project = (0, _createSvgIcon["default"])({
  as: _Project["default"],
  ariaLabel: 'project',
  category: 'file',
  displayName: 'Project'
});
var _default = Project;
exports["default"] = _default;
module.exports = exports.default;